import React from "react"
import PropTypes from "prop-types"

//i18n
import { withTranslation } from "react-i18next"

import { PageContent, CustomBreadcrumb } from "components/Common"
import Profiles from "./Organizations"
import { ModuleIds } from "constant"

const RESOURCE = ModuleIds.Organization

const OrganizationsContainer = ({ t }) => {
  const titleTag = t(`Organization`)
  return (
    <PageContent title={titleTag}>
      {/* PageTitle */}
      <CustomBreadcrumb
        breadcrumbItem={t("Organizations")}
        resource={RESOURCE}
      />

      {/* Page Body */}
      <Profiles />
    </PageContent>
  )
}

OrganizationsContainer.propTypes = {
  t: PropTypes.any,
}

export default withTranslation(["partyPage"])(OrganizationsContainer)
